// extracted by mini-css-extract-plugin
export default {"wrapper":"component_wrapper__pUSOC","container":"component_container__-Rz1c","form":"component_form__C0pRO"};